export default __webpack_public_path__ + "static/media/blueArrow.dad526e1.svg";